import { Mutation, Module, VuexModule, Action } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";

interface DonationDetails {
  name: string;
  amount: number;
  scheme_id: number;
  scheme_Name: string;
  scheme_Amount: number;
  scheme_Type: string;
}

@Module
export default class DonationModule extends VuexModule {
  donationDetails = {} as DonationDetails;

  get currentDonationDetails() {
    return this.donationDetails;
  }

  @Mutation
  [Mutations.REST_DONATION_DETAILS](): void {
    this.donationDetails = {} as DonationDetails;
  }

  @Mutation
  [Mutations.SET_DONATION_DETAILS](payload): void {
    this.donationDetails = payload;
  }

  @Action
  [Actions.SET_DONATION_DETAILS_ACTION](payload) {
    this.context.commit(Mutations.SET_DONATION_DETAILS, payload);
  }
}
